module.exports = __webpack_public_path__ + "9844f08509a56024c006bbe5a43b36e1.jpg";